var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPagePrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_page_back_32",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 32,
    height: 32,
    fill: "#999",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(13.4 11.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_358",
    "data-name": "\\uD328\\uC2A4 358",
    d: "M348.144,165.575a.6.6,0,0,1-.424-.176l-4-4a.6.6,0,0,1,0-.849l4-4a.6.6,0,0,1,.847.849l-3.575,3.576,3.575,3.575a.6.6,0,0,1-.423,1.025Z",
    transform: "translate(-343.544 -156.374)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPagePrev);
export default __webpack_public_path__ + "static/media/icon_page_prev.68f58c835eb2bb33117d53b83632d617.svg";
export { ForwardRef as ReactComponent };